import React, { useState } from "react";
import { Modal, Box, Button, Typography, Stack } from "@mui/material";
import { ReactComponent as Logo } from "../../img/logo.svg"
// import ModalLogo from "../../img/LogoPng.png"
import ModalLogo from "../../img/modalLogo.png"
import { PrimaryButton } from '../../Theme';


const BankDetailsModal = ({bankDetailModal, setBankDetailModal}) => {
  const handleClose = () => setBankDetailModal(false);
  const firstName = localStorage.getItem('firstName')
  const lastName = localStorage.getItem('lastName')
  console.log("firstName ",firstName,lastName)

  return (
    <div>
      <Modal open={bankDetailModal} onClose={handleClose} aria-labelledby="modal-title">
        <Box
            sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {xs:"95%", sm:"70%", md:"60%", lg:'50%'},
            maxWidth:"600px",
            bgcolor: "background.paper",
            boxShadow: 24,
            // py: 4,
            // px: 4,
            borderRadius: 2,
            overflow: "hidden",  
            }}
        >
              <Box
    sx={{
      maxHeight: "90vh",
      overflowY: "auto",     // <-- scrolling happens on inner box
      p: { xs: 2, sm: 3, md: 4 },
    }}
  >
                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, width: "100%" }}>
                        <img
                            src={ModalLogo}
                            alt="Logo"
                            style={{
                            width: "100%",
                            maxWidth: "180px",
                            height: "auto",
                            display: "block",
                            }}
                        />
                        </Box>
            <Typography sx={{  fontWeight: "600", mb: 2, textAlign:"center", fontSize:"1rem", textTransform:"uppercase" }} gutterBottom>Payment Details for subscription into the units of the fund</Typography>
            <Typography sx={{  fontWeight: "500", mb: 3, textAlign:"center", fontSize:"0.9rem", }} gutterBottom>Subscription monies for the Fund are to be remitted by <strong><u>electronic transfer</u></strong> to the following bank account:</Typography>


            <Stack spacing={1} sx={{gap:"8px"}}>
                <Typography sx={{  fontWeight: "600",  textAlign:"center", fontSize:"1rem", marginTop:"18px !important" }}>For SGD Transfers</Typography>
            {[
                { label: "Bank Name", value: "CIMB Bank Berhad, Singapore", textTransform:"Capitalize" },
                {label: "Bank Address", value: "30 Raffles Place, #04-01, Singapore 048622",textTransform:"none"},
                { label: "SWIFT Code", value: "CIBBSGSG",textTransform:"uppercase" },
                { label: "Currency", value: "SGD",textTransform:"none" },
                { label: "Account / Recipient Name", value: "TRADETOGETHER PTE. LTD.",textTransform:"uppercase !important" },
                { label: "Account / Recipient Address", value: "1 George Street, #10-01, Singapore 045195",textTransform:"none" },
                { label: "Account Number", value: "2001134991",textTransform:"none" },
                { label: "Reference", value: '[Please Indicate Your Name As Stated In The Subscription Agreement]',textTransform:"none" },
            ].map((item, index) => (
                <Box
                key={index}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                }}
                >
                <Typography sx={{  fontWeight: "500", flex: 1 }}>
                    {item.label}:
                </Typography>
                <Typography sx={{  flex: 1, textTransform: item.textTransform }}>
                    {item.value}
                </Typography>
                </Box>
            ))}
            <Typography sx={{  fontWeight: "600",  textAlign:"center", fontSize:"1rem", marginTop:"18px !important" }}>For USD Transfers</Typography>
            {[
                { label: "Bank Name", value: "CIMB Bank Berhad, Singapore",textTransform:"Capitalize" },
                {label: "Bank Address", value: "30 Raffles Place, #04-01, Singapore 048622", textTransform:"Capitalize"},
                { label: "SWIFT Code", value: "CIBBSGSG",textTransform:"uppercase" },
                { label: "Currency", value: "USD",textTransform:"uppercase" },
                { label: "Account / Recipient Name", value: "TRADETOGETHER PTE. LTD.",textTransform:"uppercase" },
                { label: "Account Number", value: "2001135005", textTransform:'none' },
                { label: "Reference", value: `[Please Indicate Your Name As Stated In The Subscription Agreement]`,textTransform:"none" },
            ].map((item, index) => (
                <Box
                key={index}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                }}
                >
                <Typography sx={{  fontWeight: "500", flex: 1 }}>
                    {item.label}:
                </Typography>
                <Typography sx={{  flex: 1, textTransform: item.label == 'Reference' ? "Capitalize" : "none" }}>
                    {item.value}
                </Typography>
                </Box>
            ))}
            <Typography sx={{  fontWeight: "600",  textAlign:"center", fontSize:"1rem", marginTop:"18px !important" }}>For  EUR Transfers</Typography>
            {[
                { label: "Bank Name", value: "CIMB Bank Berhad, Singapore",textTransform:"Capitalize" },
                {label: "Bank Address", value: "30 Raffles Place, #04-01, Singapore 048622", textTransform:"Capitalize"},
                { label: "SWIFT Code", value: "CIBBSGSG", textTransform:"uppercase" },
                { label: "Currency", value: "EUR", textTransform:"uppercase" },
                { label: "Account / Recipient Name", value: "TRADETOGETHER PTE. LTD.", textTransform:"uppercase" },
                // { label: "Account / Recipient Address", value: "1 George Street, #10-01, Singapore 045195" },
                { label: "Account Number", value: "2001135017", textTransform:'none' },
                { label: "Reference", value: `[Please Indicate Your Name As Stated In The Subscription Agreement]`, textTransform:"none" },
            ].map((item, index) => (
                <Box
                key={index}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                }}
                >
                <Typography sx={{  fontWeight: "500", flex: 1 }}>
                    {item.label}:
                </Typography>
                <Typography sx={{  flex: 1, textTransform: item.label == 'Reference' ? "Capitalize" : "none" }}>
                    {item.value}
                </Typography>
                </Box>
            ))}
                <Box sx={{width:"100%"}}>
                    <PrimaryButton onClick={handleClose} variant='contained' sx={{ fontWeight:"400", width:"100%", maxWidth:"100%"}}>OK</PrimaryButton>
                </Box>
            </Stack>
            </Box>
        </Box>
     </Modal>
    </div>
  );
};

export default BankDetailsModal;
